import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {
  DvDynamicFormElement,
  DvDynamicFormModule,
  DvFormUtils,
  FormOf,
} from '@devinco/ui/legacy';
import { FleetLocationForm } from '@pages/fleet/interfaces';
import { CreateGeofenceDialogFormService } from './create-geofence-dialog-form.service';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '@shared/pipes/pipes.module';
import {
  DvButtonComponent,
  DvDialogContent,
  DvDialogContentComponent,
} from '@devinco/ui/dds';

@Component({
  imports: [
    DvDynamicFormModule,
    PipesModule,
    TranslateModule,
    DvButtonComponent,
    DvDialogContentComponent,
  ],
  selector: 'app-create-geofence-dialog',
  templateUrl: './create-geofence-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./create-geofence-dialog.component.scss'],
})
export class CreateGeofenceDialogComponent
  extends DvDialogContent<undefined, CreateGeofenceDialogComponent>
  implements OnInit
{
  private formService = inject(CreateGeofenceDialogFormService);

  elements: DvDynamicFormElement[];
  formGroup: FormGroup<FormOf<FleetLocationForm>>;

  performSave(): void {
    this.dialogRef.onConfirm(this.formGroup.value);
  }

  cancel(): void {
    this.dialogRef.onCancel();
  }

  ngOnInit(): void {
    this.elements = this.formService.getElements();
    this.formGroup = DvFormUtils.createFormGroup(this.elements);
  }
}
